import { css } from '@emotion/react';
import { memo, useEffect, useRef, useState } from 'react';

import { Lightbox, removeButtonAppearance } from '@didaskill/ui/design-system';

export type ImageResourceItemProps = {
  href: string;
  alt: string;
};

export const ImageResourceItemBase = ({ href, alt }: ImageResourceItemProps) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const [width, setWidth] = useState(1024);
  const [height, setHeight] = useState(1024);

  useEffect(() => {
    if (imgRef?.current) {
      setWidth(imgRef.current.naturalWidth);
      setHeight(imgRef.current.naturalHeight);
    }
  }, []);

  return (
    <Lightbox.Item original={href} alt={alt} width={width} height={height}>
      {({ ref, open }) => (
        <button
          type="button"
          onClick={open}
          css={css`
            ${removeButtonAppearance};
            width: 40px;
            height: 40px;
          `}
        >
          <img
            css={css`
              width: 100%;
              height: 100%;
              border-radius: 8px;
            `}
            ref={ref}
            src={href}
            alt={alt}
          />
          <img
            css={css`
              display: none;
            `}
            ref={imgRef}
            src={href}
            alt={alt}
          />
        </button>
      )}
    </Lightbox.Item>
  );
};

ImageResourceItemBase.displayName = 'ImageItem';

export default memo(ImageResourceItemBase);
